import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ListingModel} from "../../../objects/listing-model";
import {environment} from "../../../../environments/environment";
import {AppComponent} from "../../../app.component";
import {ListItem} from "../../../objects/listItem";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {SharedDataService} from "../../../services/shared-data.service";
import {SubscriptionLike} from "rxjs";
import {FS3Notification} from "../../../objects/notification";
import {AppEvent} from "../../../objects/appEvent";
import {User} from "../../../objects/user";
import {DialogCanvasComponent} from "../../dialog-canvas/dialog-canvas.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {MobileContainerComponent} from "../mobile-container/mobile-container.component";
import {ConfirmationDialogComponent} from "../../confirmation-dialog/confirmation-dialog.component";
import {count} from "rxjs/operators";
import {ApiService} from "../../../api.service";
import {transferArrayItem} from "@angular/cdk/drag-drop";

@Component({
  selector: 'app-user-details-component',
  templateUrl: './user-details-component.component.html',
  styleUrls: ['../mobile-container/mobile-container.component.scss']
})
export class UserDetailsComponentComponent implements OnInit {

  state: string = 'loading';
  loadingSubItems: boolean = false;
  showMyProfile: boolean = false
  isTrainer: boolean = false
  relationStatus: string
  relationAction: string
  relationParams: object
  errMsg: string = '';
  profile: User;
  userCanCallForAGame: boolean;
  activeItem: ListItem; // Element on which was called context menu
  listing: ListingModel;
  firstItemHeight = 380;
  typicalItemHeight = 94;

  @Input() viewID: string; //before component init
  @Input() popupMode: boolean;
  private sharedEventSubscription: SubscriptionLike; //user refresh after component init

  @ViewChild(CdkVirtualScrollViewport)
  viewport: CdkVirtualScrollViewport;
  constructor(public application: AppComponent,
              public mobileContainer: MobileContainerComponent,
              public dialog: MatDialog,
              public confirmationDialog: MatDialog,
              private sharedDataService: SharedDataService,) { }

  ngOnInit(): void {
    this.listing = new ListingModel();
    this.itemViewPicked(this.viewID)
    this.sharedEventSubscription = this.sharedDataService.globalEventObservable$.subscribe(
      appEvent => {
        if (appEvent.type === AppEvent.USER_SELECTED) { //user switch
          this.viewID = appEvent.data['userID'];
          this.itemViewPicked(this.viewID)
        }
        if (appEvent.type === AppEvent.COMMUNITY_CLASS_ADDED) {
          this.addGroupItem(appEvent.data['listItem'])
        }
        if (appEvent.type === AppEvent.COMMUNITY_CLASS_UPDATED) {
          this.updateGroupItem(appEvent.data['listItem'])
        }
        if (appEvent.type === AppEvent.COMMUNITY_CLASS_DELETED) {
          this.deleteGroupItem(appEvent.data['listItem'])
        }
        if (appEvent.type === AppEvent.OTHER_USER_ACTION) {
          this.friendshipClick()
        }
        if (appEvent.type === AppEvent.USER_EDIT_START_ACTION) {
          this.profileEdit()
        }
        if (appEvent.type === AppEvent.USER_BOOKINGS_START_ACTION) {
          this.startBooking()
        }
        if (appEvent.type === AppEvent.FRIEND_INVITE_START_ACTION) {
          this.friendInviteOrView()
        }
        if (appEvent.type === AppEvent.GROUP_ADD_START_ACTION) {
          this.groupEdit()
        }
        if (appEvent.type === AppEvent.SHOW_FRESH_RELATIONS) {
          this.proFileEventsData = null; //reload from server fresh data
          if(this.mobileContainer.state === 'user_view_friends') {
            this.itemViewPicked(this.application.user.id)
          } else {
            this.application.router.navigateByUrl('/squash/userview_friends/'+this.application.user.id)
          }
        }
        if (appEvent.type === AppEvent.USER_HAS_BEEN_LOGGED) { //user refresh
          this.handleItems(this.proFileEventsData);
        }
        if (appEvent.type === AppEvent.DRAGGER_USER_CHANGE && appEvent.data['context'] == 'class_users') {
          this.saveGroupMembership(appEvent);
        }
      });
  }
  ngOnDestroy() {
    this.sharedEventSubscription.unsubscribe();
  }

  private itemViewPicked(itemID) {
    this.showMyProfile = this.application.user.id == itemID;
    this.isTrainer = false;
    this.userCanCallForAGame = false;
    this.state = 'loading';

    let action_types = (itemID == this.application.user.id) ? 'club_event,players_event,profile_event' : 'club_event,players_event';
    this.application.apiService.getProfileEvents(environment['gid'],itemID,environment['g_hash'],action_types)
      .subscribe(
        data => this.handleItems(data),
        error => this.handleItemsError(error))
  }

  private proFileEventsData:object;
  private handleItems(data) {
    this.proFileEventsData = data;
    this.profile = this.proFileEventsData['profile'] as User;
    this.isTrainer = User.isTrainer(this.profile);

    if(!this.isTrainer && this.application.user.id!=this.profile.id && !User.checkProfilesForGame(this.application.user,this.profile)) {
      this.profile['shipping_name'] = AppComponent.extractUserName(this.profile['shipping_name']);
    }

    let items;
    let showMyProfile = (this.application.user.id == this.profile.id);
    let eventData = {}
    eventData['showMyProfile'] = showMyProfile;
    eventData['userID'] = this.profile.id;
    eventData['data'] = this.profile;
    //eventData['mobileViewerStateLabelKey'] = showMyProfile ? 'my_profile' : 'user_profile';
    let checkState = this.popupMode ? 'user_view' : this.mobileContainer.state;
    if(this.popupMode) {
      //this.state = 'user_view';
    }
    switch (checkState) {
      case 'user_view':
        items = this.application.apiService.extractClubEventsData(this.proFileEventsData['events']);
        this.state = 'events_view';
        eventData['mobileViewerStateLabelKey'] = showMyProfile ? 'my_profile' : (this.isTrainer ? 'trainer_profile' : 'user_profile');
        this.typicalItemHeight = 94;
        this.relationStatus = User.getRelationStatus(this.application.user,this.profile.id);
        this.relationAction = User.getRelationAction(this.application.user,this.profile.id);
        this.relationParams = UserDetailsComponentComponent.makeRelationParams(this.relationStatus,this.relationAction,this.application.user.id,this.profile)
        break;
      case 'user_view_bookings':
        items = this.application.apiService.extractClubEventsData(this.proFileEventsData['events']);
        console.log('items',items);
        items = items.filter(item => { return (['booking_add','booking_cancel','trainer_booking_add','trainer_booking_cancel','tournament_game_proposal','game_proposal'].indexOf(item['type']) !== -1) })
        this.state = 'bookings_view';
        eventData['mobileViewerStateLabelKey'] = showMyProfile ? 'my_bookings' : 'user_bookings';
        this.typicalItemHeight = 94;
        break;
      case 'user_view_friends':
        items = this.makeMyFullFriendsList();
        //items = this.application.apiService.extractProfilesData(this.profile.friends,'friend');
        this.state = 'friends_view';
        eventData['mobileViewerStateLabelKey'] = showMyProfile ? 'my_friends' : 'user_friends';
        this.typicalItemHeight = 80;
        if(!items.length) { //show add friend popup on empty list
          this.friendInviteOrView();
        }
        break;
      case 'user_view_groups':
        items = this.application.apiService.extractCommunityClasses(this.profile.classes);
        this.state = 'groups_view';
        eventData['mobileViewerStateLabelKey'] = showMyProfile ? 'my_groups' : 'user_groups';
        this.typicalItemHeight = 321;
        break;
    }

    let appEvent = new AppEvent(AppEvent.SELECTED_USER_LOADED, eventData);
    this.sharedDataService.pushAppEvent(appEvent)

    this.listing.listItems = items;
    //console.log('this.listing.listItems',this.listing.listItems)
    this.activeItem = this.listing.listItems[0];
    setTimeout(() => {
      // better to set viewport size explicitly vs some extra bottom offset
      this.viewport.setTotalContentSize(this.firstItemHeight + this.typicalItemHeight * (this.listing.listItems.length + 0.2))
    });
  }
  private handleItemsError(error) {
    this.state = 'error';
    this.loadingSubItems = false;
    this.errMsg = error.errMsg;
  }

  resumeEventsView() {
    this.application.router.navigateByUrl('/squash/userview/'+this.application.user.id)
    setTimeout(() => {
      this.handleItems(this.proFileEventsData);
    });
  }

  myTrainersPicked() {
    //todo
  }
  myFriendsPicked() {
    this.application.router.navigateByUrl('/squash/userview_friends/'+this.application.user.id)
    setTimeout(() => {
      this.handleItems(this.proFileEventsData);
    });
  }
  myBookingsPicked() {
    this.application.router.navigateByUrl('/squash/userview_bookings/'+this.application.user.id)
    setTimeout(() => {
      this.handleItems(this.proFileEventsData);
    });
  }
  myGroupsPicked() {
    this.application.router.navigateByUrl('/squash/userview_groups/'+this.application.user.id)
    setTimeout(() => {
      this.handleItems(this.proFileEventsData);
    });
  }
  private addGroupItem(data) {
    if(this.mobileContainer.state !== 'user_view_groups') {
    //if(this.state !== 'groups_view') {
      this.myGroupsPicked(); //switch to groups
      return;
    }
    this.listing.addListItem(data);
  }
  private updateGroupItem(data) {
    if(this.mobileContainer.state !== 'user_view_groups') {
    //if(this.state !== 'groups_view') {
      return;
    }
    this.listing.listItems.find((item, idx, arr) => {
      if(item['itemFullData']['uuid'] === data['itemFullData']['uuid']) {
        arr[idx] = data;
      }
    });
  }
  private deleteGroupItem(data) {
    if(this.mobileContainer.state !== 'user_view_groups') {
    //if(this.state !== 'groups_view') {
      return;
    }
    let rmIdx = -1;
    this.listing.listItems.find((item, idx, arr) => {
      if(item['itemFullData']['uuid'] === data['itemFullData']['uuid']) {
        rmIdx = idx;
      }
    });
    this.listing.listItems.splice(rmIdx, 1);
    this.listing.listItems = [...this.listing.listItems]; // force listing refresh
  }
  private clickOnClass(event, targetItem: ListItem) {
    this.application.router.navigateByUrl('/squash/classview/'+targetItem['itemFullData']['id'])
  }
  private clickOnClassShare(event, targetItem: ListItem) {
    let config = JSON.parse(targetItem['itemFullData']['configuration'])
    window.open(config['link'])
  }
  private editClass(event, targetItem: ListItem) {
    this.groupEdit(targetItem);
  }

  private assignGroupUsers(event, targetItem: ListItem) {
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      //...this.commonDialogConf,
      height: 'auto',
      //minHeight: '50%',
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '90%' : '65%',
      data: {
        application: this.application,
        state: 'user-dragger',
        payload: {context: 'class_users', item_id: targetItem.itemFullData['id']} //other data loaded separately
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
      this.makeGroupDraggerUsersLists(targetItem);
    })
  }

  private makeGroupDraggerUsersLists(targetItem: ListItem) {
    console.log('targetItem',targetItem);
    let groupUsers: ListItem[] = this.application.apiService.extractProfilesData(targetItem.itemFullData['profiles']);
    let appEventLoading = new AppEvent(AppEvent.DRAGGER_USERS_LOADING,{});
    this.sharedDataService.pushAppEvent(appEventLoading)
    if(this.profile.native_group['status'] == 'owner') {
      this.application.apiService.getClients('/', this.application.user.magic_key)
        .subscribe(
          data => {
            this.finishGroupDraggerUsersLists(data,groupUsers);
          },
          error => {
            let appEvent = new AppEvent(AppEvent.DRAGGER_USERS_ERROR,{error: error});
            this.sharedDataService.pushAppEvent(appEvent)
          })
    } else {
      let friends: ListItem[] = this.application.apiService.extractProfilesData(this.profile.friends);
      this.finishGroupDraggerUsersLists(friends,groupUsers);
    }
  }
  private finishGroupDraggerUsersLists(clients,groupUsers) {
    let pickFrom: ListItem[] = [];
    clients.map(client => {
      if(!groupUsers.find(groupUser => {
        if(client.itemFullData['id'] == groupUser.itemFullData['id']) { //important to update groupUser filter_string for searchability in dragg list
          groupUser.filter_string = client.filter_string;
          return true;
        }
        return false;
      } )) {
        pickFrom.push(client)
      }
    });
    let appEvent = new AppEvent(AppEvent.DRAGGER_USERS_LOADED,{pickFrom: pickFrom, pickTo: groupUsers});
    this.sharedDataService.pushAppEvent(appEvent)
  }
  private saveGroupMembership(appEvent: AppEvent) {
    let relationAction = (appEvent.data['action'] == 'add') ? 'add_to_class' : 'delete_from_class';
    //console.log('appEvent',appEvent,relationAction)
    this.application.apiService.relationConfirmation(environment['gid'],environment['g_hash'],appEvent.data['profile_id'],appEvent.data['item_id'],relationAction)
      .subscribe(
        data => {
          this.listing.listItems.map(group => {
            if(group.itemFullData['id'] != appEvent.data['item_id']) return
            if(appEvent.data['action'] == 'add') {
              group.itemFullData['profiles'].push(appEvent.data['targetItem']['itemFullData'] as User);
            } else {
              const idx = group.itemFullData['profiles'].findIndex(profile => profile['id'] == appEvent.data['targetItem']['itemFullData']['id'])
              if(idx != -1) {
                transferArrayItem(group.itemFullData['profiles'],[],idx,0); //move item to the dummy array
              }
            }
          })
          this.sharedDataService.pushNotification({ text: 'Updated!', type: 'success' })
        },
        error => {
          this.sharedDataService.pushNotification({ text: 'Error...', type: 'error' })
        })
  }

  messageUser() {
    if(!environment['mobile_exit_strategy']) {
      window.alert('missing mobile_exit_strategy');
      return;
    }

    if(environment['mobile_exit_strategy'] === 'viber') {
      let exit_context = '__start_private_chat_with_user_'+this.profile.id+'_'+this.profile.sig;
      window.open(environment['viber_url']+exit_context)
    }
  }

  friendshipClick() {
    let action_type = '';
    let title = '';
    let message = '';
    let actionLabel = '';

    title = this.relationParams['title'];
    message = this.relationParams['message'];
    actionLabel = this.relationParams['actionLabel'];
    action_type = this.relationParams['action_type'];

    const dialogRef = this.confirmationDialog.open(ConfirmationDialogComponent, {
      width: '22vw',
      height: '18vh',
      autoFocus: false,
      panelClass: 'common-dialog',
      data: {
        title: title,
        message: message,
        cancelLabel: AppComponent.getLabel('close'),
        actionLabel: actionLabel
      }
    });
    dialogRef.afterClosed()
      .subscribe((result) => {
        if (result && result.isConfirmed) {
          this.application.apiService
            .relationConfirmation(environment['gid'],environment['g_hash'],this.viewID,0,action_type)
            .subscribe(
              data => {
                //reload from server application.user with new friends
                //refresh above via AppEvent.USER_HAS_BEEN_LOGGED event
                this.application.getCurrentUser();
              },
              error => {
                this.sharedDataService.pushNotification({ text: 'Friendship request error', type: 'error' })
              })
          dialogRef.close()

          let notification = new FS3Notification();
          switch (action_type) {
            case 'friendship_request':
            case 'approve_as_friends':
              notification.type = 'success';
              break;
            case 'remove_from_friends':
              notification.type = 'error';
              break;
          }
          notification.text = this.relationParams['action_confirmation_label'];
          this.sharedDataService.pushNotification(notification)
        }
      })
  }

  profileEdit() {
    this.application.router.navigateByUrl('/squash/profile_edit')
  }

  startBooking() {
    const dialogRef = this.confirmationDialog.open(ConfirmationDialogComponent, {
      width: '22vw',
      height: '18vh',
      autoFocus: false,
      panelClass: 'common-dialog',
      data: {
        title: AppComponent.getLabel('start_booking_title'),
        message: AppComponent.getLabel('start_booking_message'),
        //cancelLabel: AppComponent.getLabel('close'),
        actionLabel: AppComponent.getLabel('continue_in_chat_bot2')
      }
    });
    dialogRef.afterClosed()
      .subscribe((result) => {
        if (result && result.isConfirmed) {
          dialogRef.close()
          if(!environment['mobile_exit_strategy']) {
            window.alert('missing mobile_exit_strategy');
            return;
          }

          if(environment['mobile_exit_strategy'] === 'viber') {
            let exit_context = '__exit_for_bookingp';
            window.open(environment['viber_url']+exit_context)
          }
        }
      })
  }

  friendInviteOrView(profile: User = null) {
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      height: 'auto',
      data: {
        application: this.application,
        state: 'friend-invitation',
        payload: {
          profile: profile
        }
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((confirmed) => {
        if(confirmed) {
        }
      })
  }

  comingSoon() {
    const event = new FS3Notification();
    event.text = AppComponent.getLabel('coming_soon');
    event.type = 'info';
    this.sharedDataService.pushNotification(event);
  }
  pickPlayerForGame() {
    //console.log('checkProfileForGame',User.checkProfilesForGame(this.application.user,this.profile))
    // if(environment['mobile_exit_strategy'] === 'viber') {
    //   let exit_context = '__club_player_call_to_game_'+this.viewID+'_'+this.profile['sig'];
    //   window.open(environment['viber_url']+exit_context)
    // }
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      //...this.commonDialogConf,
      height: '50%',
      minHeight: '50%',
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '90%' : '65%',
      data: {
        application: this.application,
        state: 'game-proposal',
        payload: {
          profile: this.profile,
        }
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((confirmed) => {
        console.log('confirmed',confirmed);
      })
  }

  groupEdit(listItem: ListItem = null) {
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      //...this.commonDialogConf,
      height: 'auto',
      //minHeight: '50%',
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '90%' : '65%',
      data: {
        application: this.application,
        state: 'edit-group-form',
        payload: {
          profileItem: this.profile,
          item: listItem,
        }
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((confirmed) => {
        console.log('confirmed',confirmed);
      })
  }

  private makeMyFullFriendsList(): ListItem[] {
    let myProfileViewMode = (parseInt(this.viewID) == this.application.user.id)
    let items: ListItem[] = this.application.apiService.extractProfilesData(this.profile.friends,'friend');
    let referrals: ListItem[] = this.application.apiService.extractProfilesData(this.profile.referrals,'my_referral');
    if(referrals.length) {
      referrals.forEach(referral => {
        const found = items.find(friend => friend['itemFullData']['id'] == referral['itemFullData']['id'])
        if(!found) {
          items.unshift(referral);
        } else {
          found.type = 'my_friend_referral';
        }
      });
    }
    if(myProfileViewMode) { //append more friends from classes
      this.profile.classes.forEach((classObj, idx, arr) => {
        classObj['profiles'].forEach((profileObj, pIdx, pArr) => {
          if(parseInt(profileObj['id']) == this.application.user.id) { //self skip
            return;
          }
          //if pending membership and viewer is class owner -> add to the top of the list
          if(profileObj['membership'] == 'pending' && parseInt(classObj['profile_id']) == this.application.user.id) {
            let newItem: ListItem = this.application.apiService.extractProfilesData([profileObj],'friend')[0];
            let relation_params = {};
            relation_params['status'] = 'pending';
            relation_params['action'] = 'my_approve';
            relation_params['__class_owner'] = true;
            relation_params['__class'] = classObj;
            newItem['itemFullData']['relation_params'] = relation_params
            items.unshift(newItem)
          } else if(profileObj['membership'] == 'active') { //proxy friends - add to the bottom of the list
            const found = items.find(elem => parseInt(elem['itemFullData']['id']) == parseInt(profileObj['id']))
            if(!found || parseInt(classObj['profile_id']) == this.application.user.id) { //for class owner show record every time
              let newItem: ListItem = this.application.apiService.extractProfilesData([profileObj],'friend')[0];
              let relation_params = {};
              relation_params['status'] = 'active';
              relation_params['__class_owner'] = parseInt(classObj['profile_id']) == this.application.user.id;
              relation_params['__class'] = classObj;
              newItem['itemFullData']['relation_params'] = relation_params
              items.push(newItem)
            }
          }
        })
      })
    }
    return items;
  }

  public static makeRelationParams(relationStatus: string, relationAction: string, sourceID: number, targetProfile: User, viewAsSource: boolean = true): object {
    let params = {};
    params['title'] = params['message'] = params['actionLabel'] =
    params['action_type'] = params['action_confirmation_label'] = params['action_icon'] = '';
    if(sourceID == targetProfile.id) return params; //self user

    switch (relationStatus) {
      case 'active':
        params['title'] = AppComponent.getLabel('remove_from_friends_popup_title2');
        params['message'] = AppComponent.getLabel('remove_from_friends_popup_description2');
        params['actionLabel'] = AppComponent.getLabel('remove_from_friends_popup_title');
        params['action_type'] = 'remove_from_friends';
        params['action_confirmation_label'] = AppComponent.getLabel('remove_from_friends_popup_confirmation');;
        params['action_icon'] = 'person_remove';
        break;
      case 'pending':
        if(viewAsSource) {
          switch (relationAction) {
            case 'wait_approve':
              params['title'] = AppComponent.getLabel('wait_friend_approval_popup_title');
              params['message'] = AppComponent.getLabel('wait_friend_approval_popup_description');
              params['actionLabel'] = '';
              params['action_type'] = '';
              params['action_confirmation_label'] = '';
              params['action_icon'] = 'info';
              break;
            case 'my_approve':
              params['title'] = AppComponent.getLabel('approve_as_friends_popup_title');
              params['message'] = AppComponent.getLabel('approve_as_friends_popup_description')+' "'+targetProfile.shipping_name+'"';
              params['actionLabel'] = AppComponent.getLabel('confirm');
              params['action_type'] = 'approve_as_friends';
              params['action_confirmation_label'] = AppComponent.getLabel('approve_as_friends_popup_confirmation');;
              params['action_icon'] = 'person_add';
              break;
          }
        } else {
          switch (relationAction) {
            case 'wait_approve':
              params['title'] = AppComponent.getLabel('approve_as_friends_popup_title');
              params['message'] = AppComponent.getLabel('approve_as_friends_popup_description')+' "'+targetProfile.shipping_name+'"';
              params['actionLabel'] = AppComponent.getLabel('confirm');
              params['action_type'] = 'approve_as_friends';
              params['action_confirmation_label'] = AppComponent.getLabel('approve_as_friends_popup_confirmation');;
              params['action_icon'] = 'person_add';
              break;
            case 'my_approve':
              params['title'] = AppComponent.getLabel('wait_friend_approval_popup_title');
              params['message'] = AppComponent.getLabel('wait_friend_approval_popup_description');
              params['actionLabel'] = '';
              params['action_type'] = '';
              params['action_confirmation_label'] = '';
              params['action_icon'] = 'info';
              break;
          }
        }
        break;
      default:
        params['title'] = AppComponent.getLabel('send_friendship_request_popup_title');
        params['message'] = AppComponent.getLabel('send_friendship_request_popup_description');
        params['actionLabel'] = AppComponent.getLabel('add_to_friends');
        params['action_type'] = 'friendship_request';
        params['action_confirmation_label'] = AppComponent.getLabel('send_friendship_request_popup_confirmation');;
        params['action_icon'] = 'person_add';
        break;
    }
    return params;
  }
}
